module.exports = __webpack_public_path__ + "img/Check-survol.67f803d9.svg";